module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main update_trip_wrp"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "c-pointer"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateTrip()
      }
    }
  }, [_vm._v("Update Segregation Plant Trip")])])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_data_paddi"
  }, [_c('div', {
    staticClass: "shedule_date_data"
  }, [_c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Schedule Date and Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.scheduleTime ? _vm.details.scheduleTime : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Start Date and Time")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.details.startTime ? _vm.details.startTime : "--") + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip End Date and Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.endTime ? _vm.details.endTime : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Start Point")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.details.dumpYardId[0].dumpYardName ? _vm.details.dumpYardId[0].dumpYardName : "--") + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip End Point")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.details.segregationId[0].plantName ? _vm.details.segregationId[0].plantName : "--") + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Driver")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.details.driverId[0].firstName +
    " " +
    _vm.details.driverId[0].lastName) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Vehicle")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.vehicleId[0].vNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Waste (KG)")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.details.totalWeight ? _vm.details.totalWeight : "--") + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Status")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tripStatus))])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77e6f3a5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e6f3a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/transportPointTrip/viewTransportPointTrip.vue
// module id = 2350
// module chunks = 0